import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

export const createNewTag = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_NEW_TAGS}`, body);

export const createWidget = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_WIDGET}`, body);

export const getAllTags = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_TAGS}`);

export const getAllWidgets = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_WIDGET}`);

export const updateTag = async (body, tag_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_TAGS}/${tag_id}`, body);

export const deleteTag = async (tag_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_TAGS}/${tag_id}`);

export const deleteWidget = async (widget_id) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_WIDGET}/${widget_id}`);

export const updateWidget = async (body, widget_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_WIDGET}/${widget_id}`, body);
